import { useCallback } from 'react';

import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

type UsePageConflictAnalyticsProps = {
	source: string;
	actionSubjectId: string;
	contentId?: string;
	contentType?: string;
	collabService?: string;
	version?: number;
};

export const usePageConflictAnalytics = ({
	source,
	actionSubjectId,
	contentId,
	contentType,
	collabService,
	version,
}: UsePageConflictAnalyticsProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const triggerPageConflictAnalytics = useCallback(
		(errorMessage: any, extraData: { [key: string]: any } = {}) => {
			pageConflictAnalyticsEvent(
				source,
				actionSubjectId,
				{
					contentId,
					contentType,
					collabService,
					version,
					errorMessage,
					...extraData,
				},
				createAnalyticsEvent,
			);
		},
		[createAnalyticsEvent, source, actionSubjectId, contentId, contentType, collabService, version],
	);

	return { triggerPageConflictAnalytics };
};

export const pageConflictAnalyticsEvent = (
	source: string,
	actionSubjectId: string,
	attributes: any,
	createAnalyticsEvent?: CreateUIAnalyticsEvent,
) => {
	if (createAnalyticsEvent) {
		createAnalyticsEvent({
			type: 'sendTrackEvent',
			data: {
				source,
				action: 'error',
				actionSubject: 'pageConflict',
				actionSubjectId,
				attributes,
			},
		}).fire();
	}
};
